/**
 * custom-cart-subtotal.js
 *
 * Rewrites the cart subtotal after AJAX cart mutations, because the theme's
 * own JS (and third-party fetch interference) writes cart.total_price from
 * /cart.js — which does not know about BCF-configured bikes.
 *
 * Configured bikes sit in the cart as a 1-øre placeholder variant carrying
 * the real price in the _MSRP line item property. The corrected total is:
 *
 *   total_price − (configured units × 1 øre) + Σ(_MSRP × 100 × quantity)
 *
 * This mirrors the Liquid correction in sections/main-cart.liquid and
 * sections/quick-cart.liquid — if the placeholder price (0,01 DKK) or the
 * property name ever changes, all three places must change together.
 */
(function () {
  function formatDKK(cents) {
    return (
      new Intl.NumberFormat('da-DK', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(cents / 100) + ' DKK'
    );
  }

  function correctedTotalCents(cart) {
    var msrpCents = 0;
    var msrpUnits = 0;

    cart.items.forEach(function (item) {
      var raw = item.properties && item.properties._MSRP;
      if (raw == null) return;

      // The BCF widget delivers a number; tolerate a plain decimal string too.
      var value = typeof raw === 'number' ? raw : parseFloat(raw);
      if (!isFinite(value) || value <= 0) return;

      msrpCents += Math.round(value * 100) * item.quantity;
      msrpUnits += item.quantity; // each unit is a 1-øre placeholder
    });

    return cart.total_price - msrpUnits + msrpCents;
  }

  function updateSubtotal() {
    fetch('/cart.js')
      .then(function (r) {
        return r.json();
      })
      .then(function (cart) {
        var total = formatDKK(correctedTotalCents(cart));

        // Target ONLY the price span, not the whole subtotal container —
        // the previous version overwrote the container's textContent and
        // destroyed the "Subtotal" heading alongside it.
        document
          .querySelectorAll('.cart__footer-subtotal .ff-product-price')
          .forEach(function (el) {
            el.textContent = total;
          });
      })
      .catch(function () {});
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var url =
      typeof arguments[0] === 'string'
        ? arguments[0]
        : (arguments[0] && arguments[0].url) || '';
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(function (res) {
        if (res.ok) setTimeout(updateSubtotal, 150);
      });
    }
    return p;
  };
})();